import { render, staticRenderFns } from "./OrdersInformation.vue?vue&type=template&id=09c404bd&scoped=true&"
import script from "./OrdersInformation.vue?vue&type=script&lang=js&"
export * from "./OrdersInformation.vue?vue&type=script&lang=js&"
import style0 from "./OrdersInformation.vue?vue&type=style&index=0&id=09c404bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c404bd",
  null
  
)

export default component.exports